import {Box,Grid,Button,Paper,InputBase,MenuItem,TextField,Breadcrumbs,Link,Typography,Menu} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSupplierList } from "api/hooks/inventory";
import {  useItemBatchwiseStockReportList } from "api/hooks/reports";
import { useSelector } from "react-redux";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { PDFDownloadLink } from "@react-pdf/renderer";
import BatchwiseItemStockReportPdf from "scenes/reports/pdfForms/inventory/batchwiseItemStockReportPdf";
import { currencyFormatter } from "utilities/currencyFormatter";

export default function BatchwiseItemStockReport({ setIsSuccess }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const user = useSelector((state) => state.authReducer.user);
  const {itemBatchwiseStockReportList, isLoadingItemBatchwiseStockReportList, setSearch, setSupplier} = useItemBatchwiseStockReportList(1, business_branch_id);
  const { supplierList } = useSupplierList(1, business_branch_id);

  const [openExportOptions, setOpenExportOptions] = useState(false);
  const [anchorE1, setAnchorE1] = useState(null);

  const handleClickOpen = (event) => {
    setAnchorE1(event.currentTarget);
    setOpenExportOptions(true);
  };

  const handleClose = () => {
    setOpenExportOptions(false);
  };

  const handleChangeSupplierFilter = async (e) => {
    setSupplier(e.target.value);
  };

  const [searchContent, setSearchContent] = useState("");

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value);
  };

  const handleClickSearch = async () => {
    setSearch(searchContent);
  };

  const columns = [
    { label: "Item", width: 300 },
    { label: "Description", width: 300 },
    { label: "Current Stock", align: "center" },
    { label: "Batch", align: "center" },
    { label: "Expiry Date" },
    { label: "Unit" },
    { label: "Cost Price" },
    { label: "Supplier" },
  ];

  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Batchwise Item Stock Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={4}>
              <Paper
                sx={{
                  my: "4px",
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  minWidth: 170,
                  maxWidth: 300,
                }}
              >
                <InputBase
                  placeholder="Search Item Name"
                  value={searchContent}
                  onChange={handleSearchInput}
                  sx={{ ml: 1, flex: 1 }}
                />
                <IconButton onClick={handleClickSearch}>
                  <SearchIcon />
                </IconButton>
              </Paper>
            </Grid>

            <Grid xs={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>FILTER BY SUPPLIER:</h4>

                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                  }}
                >
                  <TextField
                    label="SUPPLIERS"
                    select
                    defaultValue="all"
                    size="small"
                    onChange={(e) => {
                      handleChangeSupplierFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width: "100%",
                    }}
                  >
                    <MenuItem key={"DEFAULT"} value="all">
                      ALL
                    </MenuItem>
                    {supplierList.map((row, index) => {
                      return (
                        <MenuItem key={index} value={row.id}>
                          {row.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Paper>
              </Box>
            </Grid>
            <Grid xs={2} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                anchorE1={anchorE1}
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
              <Menu
                style={{ marginRight: "30px" }}
                anchorEl={anchorE1}
                open={openExportOptions}
                onClose={handleClose}
              >
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  <PDFDownloadLink document={<BatchwiseItemStockReportPdf viewData={{ report_detail: itemBatchwiseStockReportList,}}  printedBy={user.first_name + ' ' + user.last_name}/>} fileName={`Item Purchase Summative Report`}>
                    PDF
                  </PDFDownloadLink>
                </MenuItem>    
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  EXCEL
                </MenuItem>  
              </Menu>
            </Grid>
          </Grid>
        </Box>

        <ReportTable
          columns={columns}
          rows={itemBatchwiseStockReportList}
          loading={isLoadingItemBatchwiseStockReportList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id ?? index} index={index}>
              <RCell>{row.related_product.product_name}</RCell>
              <RCell>{row.related_product.description}</RCell>
              <RCell align="center">{row.remaining_quantity}</RCell>
              <RCell align="center">{row.batch}</RCell>
              <RCell>{moment(row.expiry_date).format("L")}</RCell>
              <RCell>{row.related_product_unit.related_business_product_unit.name}</RCell>
              <RCell>{currencyFormatter(parseFloat(Number(row.smallest_unit_unit_cost) * Number(row.remaining_quantity)))}</RCell>
              <RCell>{row.related_product_purchase.related_supplier.name}</RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
